import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../shared/api.service';

@Injectable({
    providedIn: 'root'
})
export class PositionService {

    constructor(private api: ApiService) { }

    list(departmentId?: number | string | null): Observable<any> {
        const query = departmentId ? `?department_id=${departmentId}` : '';
        return this.api.get(`hr/position/list${query}`);
    }
}
